import { Button, Form, Input, Modal, Select } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { MyValidateMessages } from '../../../../utils/validateMessaage.js'
import { newAdministratior } from '../../../../api/api.js'
import './index.css'
const NewMember = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {setIsFresh} = props
  const [form] = useForm()
  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    form.validateFields().then((res) => {
      // console.log(res)
      newAdministratior(res).then((ress) => {
        console.log(ress)
        setIsFresh((pre) => !pre)
      })
      setIsModalOpen(false)
    })
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  }
  return (
    <>
      <Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
        新建{' '}
      </Button>

      <Modal
        title="新建成员"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        validateMessages={MyValidateMessages}
        className="newMember_modal"
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
        >
          <Form.Item
            rules={[
              {
                required: true,
                max: 10,
              },
            ]}
            label="昵称"
            name="nickname"
          >
            <Input style={{ width: '330px' }} placeholder="上限10字" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                max: 20,
              },
            ]}
            label="用户名"
            name="username"
          >
            <Input style={{ width: '330px' }} placeholder="上限20字" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                max: 20,
              },
              {
                // 校验密码
                validator: (rule, value, callback) => {
                  // 校验密码强度
                  //密码必须包含字母，数字，特殊符号中的两种
                  const passwordReg = /^(?![a-zA-Z]+$)(?![0-9]+$)(?![\W_]+$)/
                  if (value) {
                    if (!passwordReg.test(value)) {
                      callback(
                        new Error(
                          '密码必须包含字母、数字、特殊符号的两种及以上'
                        )
                      )
                    }
                  }
                  callback()
                },
              },
            ]}
            label="密码"
            name="password"
          >
            <Input
              style={{ width: '330px' }}
              placeholder="请包含字母、数字、特殊符号的两种及以上"
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label="角色"
            name="authority"
          >
            <Select
              placeholder="请选择"
              style={{ textAlign: 'left' }}
              mode="multiple"
            >
              <Select.Option value={1}>超级管理员</Select.Option>
              <Select.Option value={2}>管理员</Select.Option>
              <Select.Option value={3}>审核员</Select.Option>
              <Select.Option value={4}>房源管理员</Select.Option>
              <Select.Option value={5}>内容管理员</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
export default NewMember
